import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { ConnectedProps, connect } from "react-redux"
import Toggle from "react-toggle"
import ReactTooltip from "react-tooltip"
import Icon from "../common/icon/icon.component"
import { isError } from "../state/helpers/Error"
import { setBottomPriceEnabled, updateBottomPriceEnabledAction } from "../state/pricing/actions"
import PreferenceService from "../state/user/PreferenceService"
import "./bottomPrice.scss"

type OwnProps = object
const BottomPriceToggle = (props: Props) => {

    const [isEnabled, setIsEnabled] = useState<boolean>(false)
    const fetchUserBottomPricePreference = () => {
        PreferenceService.get(AppContext.getUserLoggedIn().id).then((preference) => {
            if (!isError(preference)) {
                setIsEnabled(preference.isBottomPriceEnabled())
                props.updateBottomPriceEnabledAction(preference.isBottomPriceEnabled())
            }
        })
    }

    useEffect(() => {
        fetchUserBottomPricePreference()
    }, [])

    const updateUserBottomPricePreference = (enabled) => {
        const id = AppContext.getUserLoggedIn().id
        props.setBottomPriceEnabled(id, enabled)
        setIsEnabled(enabled)
    }

    return <>{
        AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBottomLinePrice) &&
        <div className="col-2 d-flex align-items-center justify-content-end pr-0">
            <a data-tip data-for={"bottom-price-icon"} style={{color: "black"}}>
                <Icon value="arrow-circle-down" size={"15px"}/>
            </a>
            <ReactTooltip
                id={"bottom-price-icon"}
                multiline={true}
                place={"top"}
                className={"bottom-price-tooltip"}
                type={"dark"}
            >
                <FormattedMessage
                    id="quote.edit.bottom.price.toggle.tooltip"
                    defaultMessage="Display the bottom line price and total you shouldn't go under"
                />
            </ReactTooltip>
            <div className={"pt-1 bottom-price-toggle"}>
                <Toggle
                    id={"bottom-line"}
                    defaultChecked={isEnabled}
                    checked={isEnabled}
                    icons={false}
                    onChange={() => updateUserBottomPricePreference(!isEnabled)}
                />
            </div>
        </div>
    }
    </>
}

const mapState = (state, props: OwnProps) => ({...props})

const mapDispatch = {
    updateBottomPriceEnabledAction,
    setBottomPriceEnabled,
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(BottomPriceToggle))


// WEBPACK FOOTER //
// ./src/bottom-line/toggle.component.tsx